// فعالیت‌های یک کارمند
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa  = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

const EMPTY = { project_id: 0, project: '', from_date: '', percent: '', remark: '', is_active: true };

const API = (path, opts = {}) => fetch(`/api/budget${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

function Lookup({ label, value, endpoint, onPick, flex = 1 }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`);
    if (j.ok) { setRows(j.rows); setOpen(true); }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => search(q)} onChange={e => search(e.target.value)} placeholder="جستجو..." style={ui.input} />
      {value && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 700, maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function BudgetPeopleActivityDetail({ user, onBack, person }) {
  // مجوز دکمه‌های فرم FRMPEOPLEACTIVITYDETAIL — دیدن = دسترسی
  const vbf = useFormButtons('FRMPEOPLEACTIVITYDETAIL', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const PID = person?.id;
  const year = person?.year;

  const [data,     setData]     = useState([]);
  const [sumPct,   setSumPct]   = useState(0);
  const [selected, setSelected] = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [modal,    setModal]    = useState(null);
  const [form,     setForm]     = useState(EMPTY);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const [toast,    setToast]    = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const cols = ['فعالیت', 'از تاریخ', 'درصد', 'توضیح', 'وضعیت'];
  const initW = [280, 110, 90, 220, 110];
  const [colW, setColW] = useState(initW);
  const colWRef = useRef(initW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async () => {
    if (!PID) return;
    setLoading(true); setError(''); setSelected(null);
    const j = await API(`/people-activity/${PID}/detail/?year=${year}`);
    setLoading(false);
    if (j.ok) { setData(j.data); setSumPct(j.sum_percent || 0); }
    else setError(j.msg);
  }, [PID, year]);

  useEffect(() => { load(); }, [load]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm({ ...EMPTY, from_date: '' }); setError(''); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      project_id: selected.project_id, project: selected.project, from_date: selected.from_date,
      percent: selected.percent, remark: selected.remark, is_active: selected.is_active,
    });
    setError(''); setModal('edit');
  };
  const openDel = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    const body = JSON.stringify({ ...form, year, people_id: PID });
    const j = modal === 'new'
      ? await API(`/people-activity/${PID}/detail/create/`, { method: 'POST', body })
      : await API(`/people-activity/detail/${selected.id}/update/`, { method: 'PUT', body });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/people-activity/detail/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); }
    else setError(j.msg);
  };

  const complete = sumPct === 100;
  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
      </div>
      <div style={{ padding: '6px 14px', background: complete ? '#1b5e20' : '#c62828', color: '#fff', borderRadius: '20px', fontSize: '12px', fontWeight: '700', marginRight: 'auto', alignSelf: 'flex-end' }}>
        جمع درصد: {toFa(sumPct)}٪ {complete ? '(کامل)' : '(ناقص)'}
      </div>
      {loading && <span>⏳</span>}
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack}
        title={`فعالیت‌های ${person?.name || ''}`}
        subtitle={`کد ملی ${toFa(person?.melli_code || '—')} — سال ${toFa(year)}`}
        toolbar={toolbar} error={!modal ? error : ''}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((h, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              const tc  = sel ? '#fff' : '#111';
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer', opacity: r.is_active ? 1 : 0.55 }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.project}>{r.project || '•'}</td>
                  <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{toFa(r.from_date) || '•'}</td>
                  <td style={{ ...ui.tdNum, color: sel ? '#fff' : '#1a237e', fontWeight: '700' }}>{toFa(r.percent)}٪</td>
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.remark}>{r.remark || '•'}</td>
                  <td style={{ ...ui.td, fontSize: '11px', color: sel ? '#fff' : (r.is_active ? '#1b5e20' : '#c62828') }}>{r.is_active ? 'فعال' : 'غیرفعال'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 فعالیتی ثبت نشده است</div>}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '620px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ فعالیت جدید' : '✎ ویرایش فعالیت'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={ui.row}>
                <Lookup label="فعالیت" value={form.project} endpoint="/people-activity/lookup/project/"
                  onPick={r => setForm(f => ({ ...f, project_id: r.id, project: r.display }))} flex={2} />
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>از تاریخ</label>
                  <JalaliDatePicker value={form.from_date} onChange={v => F('from_date', v)} placeholder="از تاریخ" />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>درصد فعالیت</label>
                  <input type="number" value={form.percent} onChange={e => F('percent', e.target.value)} style={ui.input} />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>توضیح</label>
                  <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                </div>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', fontSize: '13px', color: '#444', cursor: 'pointer' }}>
                <input type="checkbox" checked={form.is_active} onChange={e => F('is_active', e.target.checked)} style={{ marginLeft: '8px' }} />
                فعال
              </label>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '420px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف فعالیت</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              {selected?.project} — {toFa(selected?.percent)}٪
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
